import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { individualpayments } from 'models/individualpayments'; // Importing individualpayments model

/**
 * PaymentHistoryView class extends JetView to create a payment history view.
 */
export default class PaymentHistoryView extends JetView {
    /**
     * Configures the view layout and data table structure.
     * @returns {Object} Configuration object for the data table.
     */
    config() {
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date format for displaying dates
        return {
            view: 'datatable', // Specifies the view type as a data table
            select: true, // Enables row selection
            tooltip: true, // Enables tooltips for table cells
            columns: [
                // Defines the columns of the data table
                {
                    id: 'date', // Unique identifier for the column
                    header: 'Fecha', // Header text for the column
                    sort: 'date', // Enables sorting by date
                    format: dateFormat, // Applies date formatting
                    width: 155, // Sets the column width
                    tooltip: '', // Tooltip content (empty)
                },
                {
                    id: 'type', // Unique identifier for the column
                    header: 'Tipo', // Header text for the column
                    sort: 'string', // Enables sorting by string
                    adjust: 'header', // Adjusts column width based on header
                    tooltip: (obj) => (obj.type ? 'Bought' : 'Sold'), // Tooltip based on type
                    template: (obj) => {
                        // Custom template for rendering the cell
                        let type = obj.type ? 'left bought' : 'right sold'; // Determines icon direction
                        return `<span class="webix_icon mdi mdi-arrow-${type}"></span>`; // Returns icon HTML
                    },
                },
                {
                    id: 'item', // Unique identifier for the column
                    header: 'Item', // Header text for the column
                    sort: 'string', // Enables sorting by string
                    fillspace: 8, // Allows the column to fill available space
                    tooltip: '#item#', // Tooltip displays item name
                },
                {
                    id: 'number', // Unique identifier for the column
                    header: 'Quantity', // Header text for the column
                    sort: 'int', // Enables sorting by integer
                    width: 67, // Sets the column width
                    tooltip: '', // Tooltip content (empty)
                },
                {
                    id: 'sum', // Unique identifier for the column
                    header: 'Cost', // Header text for the column
                    sort: 'int', // Enables sorting by integer
                    format: webix.i18n.priceFormat, // Applies price formatting
                    exportType: 'number', // Specifies export type for the column
                    adjust: 'data', // Adjusts column width based on data
                    tooltip: '', // Tooltip content (empty)
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up data synchronization and event listeners.
     * @param {Object} view - The view instance.
     */
    init(view) {
        const cur_user = this.getParam('user', true); // Retrieves the current user parameter
        view.sync(individualpayments, function () {
            // Synchronizes view with individualpayments model
            if (cur_user) this.filter((obj) => obj.id % 6 === cur_user % 6); // Filters data based on user ID
        });
        this.on(this.app, 'person:select', (person) => {
            // Event listener for person selection
            individualpayments.waitData.then(() => {
                // Waits for data to be ready
                view.filter((obj) => {
                    // Filters data based on selected person's ID
                    return obj.id % 6 === person.id % 6;
                });
            });
        });
    }
}

// FILE DOCUMENTED
